import Components from "slotworks/components/components";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import RequestFreespin from "slotworks/state-machine/standard/states/request-freespin";

export default class GameiomRequestFreespin extends RequestFreespin {

    public onEnter() {
        gameWrapper.setBusy();
        super.onEnter();
    }

    public error() {
        // Let the wrapper take over
        SmartUIFlags.set(SmartUIFlag.PROMPT, true);
        gameWrapper.disableFeatureMode();
        gameWrapper.setIdle();

        Components.matrix.reset();
        Services.autoplay.stop();
    }
}
